/**
 * Renders a string with the matched query term marked (F6).
 *
 * The matched runs are wrapped in `<mark>`, which is both the semantically
 * correct element and one screen readers can announce. The colour is a wash of
 * blue rather than green: green is reserved for data values (§4.2), and a
 * highlighted substring is emphasis, not a datum.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.11, PRD F6, §4.2
 */
import { highlightSegments } from '../../../lib/highlight';

export interface HighlightProps {
  text: string;
  query: string;
}

export function Highlight({ text, query }: HighlightProps): React.JSX.Element {
  const segments = highlightSegments(text, query);

  return (
    <>
      {segments.map((segment, index) =>
        segment.matched ? (
          <mark
            /* Index keys are safe: the segment list is derived fresh on every
               render and never reordered in place. */
            key={index}
            className="bg-blue/15 text-navy-text rounded-[3px] font-medium"
          >
            {segment.text}
          </mark>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </>
  );
}
